import { CreateSubscriptionRequestInterface } from '@/data/payload/api/SubscriptionRequest'
import { SubscriptionRepositoryInterface } from '@/data/persistences/repositories/contracts/SubscriptionRepositoryInterface'
import { Subscription, Subscriptions } from '@/domain/entities/Subscription'
import { injectable } from 'tsyringe'

@injectable()
export class SubscriptionPresenter {
    private repository: SubscriptionRepositoryInterface

    constructor(repository: SubscriptionRepositoryInterface) {
        this.repository = repository
    }

    public getAll(params: Map<string, unknown>): Promise<Subscriptions> {
        return this.repository.getAll(params)
    }

    public get(subscriptionId: string): Promise<Subscription> {
        return this.repository.get(subscriptionId)
    }

    public delete(subscriptionId: string): Promise<boolean> {
        return this.repository.delete(subscriptionId)
    }

    public createSubscription(payload: CreateSubscriptionRequestInterface): Promise<boolean> {
        return this.repository.createSubscription(payload)
    }

    public update(id: string, payload: CreateSubscriptionRequestInterface): Promise<boolean> {
        return this.repository.update(id, payload)
    }
}